import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addBookmarkRes;
export const addBookmarkTodo = createAsyncThunk('addBookmark', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/add_bookmark',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": val.course_id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addBookmarkRes = res.data
    } catch (error) {
        return addBookmarkRes = error.response.data
    }
})